import React from "react";
import { Card } from "../modules/Deposits";

export function DepositsCardPage(props) {
  return <Card {...props} />;
}
